import { Body, Caption, IconButton, Row } from "@gadgetinc/widgets";
import { EditIcon } from "@gadgetinc/widgets/src/icons/EditIcon";
import { InfoIcon } from "@gadgetinc/widgets/src/icons/InfoIcon";
import { useStyletron } from "baseui";
import React from "react";

export const ClickToEditText = (props: { text: string; onEdit: () => void }) => {
  const { text, onEdit } = props;
  const [_, $theme] = useStyletron();
  return (
    <Row
      $style={{
        width: "100%",
        gap: $theme.sizing.scale300,
        backgroundColor: $theme.colors.alpha50,
        borderRadius: $theme.borders.radius300,
        padding: $theme.sizing.scale300,
        alignItems: "flex-start",
      }}
    >
      <Body $style={{ marginRight: "auto" }}>{text}</Body>

      <IconButton label="Edit" onClick={onEdit} $style={{ marginLeft: "auto" }}>
        <EditIcon />
      </IconButton>
    </Row>
  );
};

export const InfoCaption = (props: { info: string }) => {
  const { info } = props;
  const [_, $theme] = useStyletron();
  return (
    <Row $style={{ alignItems: "center", gap: $theme.sizing.scale100 }}>
      <InfoIcon />
      <Caption>{info}</Caption>
    </Row>
  );
};
